module.exports = __webpack_public_path__ + "static/media/fentonsLogo.e48f312b.png";